export class PageHeader {
  constructor() {
    this.docElem = document.documentElement;
    this.header = document.querySelector( '.cbp-af-header' );
    this.didScroll = false;
    this.changeHeaderOn = 20;

    this.init();
  }

  init = () => {
    if(this.header){
      window.addEventListener( 'scroll', ( event ) => {
        if( !this.didScroll ) {
          this.didScroll = true;
          setTimeout( this.scrollPage, 250 );
        }
      }, false );

      if((document.body.getBoundingClientRect()).top !== 0){
        this.header.classList.add('cbp-af-header-shrink');
        document.body.classList.add('header-shrink');
      }
    }
  }

  scrollPage = () => {
    let sy = this.scrollY();
    if ( sy >= this.changeHeaderOn ) {
      this.header.classList.add('cbp-af-header-shrink');
      document.body.classList.add('header-shrink');
    }
    else {
      this.header.classList.remove('cbp-af-header-shrink');
      document.body.classList.remove('header-shrink')
    }
    this.didScroll = false;
  }

  scrollY = () => {
    return window.pageYOffset || this.docElem.scrollTop;
  }
}
